import { render, staticRenderFns } from "./ApiOrderAllocation.vue?vue&type=template&id=bb0840ac&scoped=true"
import script from "./ApiOrderAllocation.vue?vue&type=script&lang=js"
export * from "./ApiOrderAllocation.vue?vue&type=script&lang=js"
import style0 from "./ApiOrderAllocation.vue?vue&type=style&index=0&id=bb0840ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0840ac",
  null
  
)

export default component.exports